import { Component, Input, OnInit, signal } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { formatFromDate } from "src/app/common/datetime_utility";
import { RelatedFindingModel } from "src/app/models/api/issue.model";
import { SortColumn } from "src/app/models/sortColumn.model";
import { ITableColumn } from "src/app/models/tableColumns";
import { issueFindingsTableColumns } from "src/app/models/tableColumns/issueFindingsTableColumns.model";
import { RelatedFindingTableRowViewModel } from "src/app/models/viewModels/RelatedFindingTableRowViewModel";

@Component({
    selector: "app-issue-findings",
    templateUrl: "./issue-findings.component.html",
    styleUrls: ["./issue-findings.component.scss"],
})
export class IssueFindingsComponent implements OnInit {
    @Input() public finding: RelatedFindingModel[] = [];

    public columns = signal<ITableColumn[]>(issueFindingsTableColumns);
    public findingsCurrentPage$ = new BehaviorSubject<RelatedFindingTableRowViewModel[]>([]);
    public isLoading$ = new BehaviorSubject<boolean>(false);
    public showNoData = false;
    public totalItems = 0;
    public pageInfo$ = new BehaviorSubject({
        number: 1,
        currSize: 1,
        maxSize: 2,
        totalItems: 1,
        totalPages: 1,
    });
    public sortedColumn$ = new BehaviorSubject<SortColumn | undefined>(undefined);

    constructor(private _router: Router) {}

    ngOnInit(): void {
        console.log(this.finding);
        this.totalItems = this.finding.length;
        this.showNoData = this.finding.length === 0;
        this.findingsCurrentPage$.next(this.finding.map((item) => this._transformToViewModel(item)));
    }

    public rowUnselected(): void {
        //console.log("Row unselected");
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public rowSelected(selectedRow: RelatedFindingTableRowViewModel): void {
        /*
        const [basePath, rawQueryString] = selectedRow.relatedFinding.link.split("?");
        const urlParams = new URLSearchParams(rawQueryString);
        const paramsObject: Record<string, string> = {};
        for (const [key, value] of urlParams.entries()) {
            paramsObject[key] = value;
        }
        this._router.navigate([basePath], {
            queryParams: paramsObject,
        });
        */
    }

    private _transformToViewModel(row: RelatedFindingModel): RelatedFindingTableRowViewModel {
        return {
            rowId: "1",
            description: row.description,
            type: row.type,
            timestamp: formatFromDate(row.timestamp),
            user: row.user,
            severity: row.severity,
            tags: row.tags,
            relatedFinding: row,
            clickable: true,
        };
    }
}
